module.exports = __webpack_public_path__ + "img/prefooter-art.a1ba911.png";